export default __webpack_public_path__ + "_/shared_modules/sprites/dist/sprite-logo@2x-b236a30f892d073c3a7244ffb074e9cf.png";